import { EventEmitter } from './event-emitter';

let INSTANCE;

export class ScrollDetector {

	constructor() {
		if(!INSTANCE) {
			INSTANCE = this;
			this.init();
		} else {
			console.error('ScrollDetector is a Singleton. Please use static methods instead');
		}
	}

	static getSelector() {
		return 'body';
	}

	init() {
		this.lastScrollPos = window.scrollY || window.pageYOffset;
		window.addEventListener('scroll', this.detectScroll.bind(this));
		window.addEventListener('orientationchange', this.detectScroll.bind(this));
	}

	detectScroll() {
		const scrollPosition = window.scrollY || window.pageYOffset;
		if(scrollPosition !== this.lastScrollPosition) {
			EventEmitter.emit('ScrollDetector:scroll', this.lastScrollPosition, scrollPosition);
			this.lastScrollPosition = scrollPosition;
		}
	}

	get lastScrollPosition() {
		return this.lastScrollPos;
	}

	set lastScrollPosition(position) {
		this.lastScrollPos = position;
	}
}
